'use strict';
/**
 * @pbdoc disableMenu
 * @name disableMenu
 * @packageName disableMenu
 */
class timeFormatter {


    stringToTimeFormat(input = "", withHours = true)  {
        let out = [];

        //lots of reverse magic to do matching back to front 
        let reverseInput = input.substring(0, withHours ? 6 : 4).split("").reverse().join("");
        let split = reverseInput.match(/\d{1,2}/g);
        if (split) {
            split = split.reverse();
            for (let i in split) {
                split[i] = split[i].split("").reverse().join("");
            }

            if (withHours) {
                out.push(typeof split[0] != 'undefined' && split[0] > 0 && split[0] < 24 ? split[0] : '00');
            }
            out.push(typeof split[1] != 'undefined' && split[1] > 0 && split[1] < 60 ? split[1] : '00');
            out.push(typeof split[2] != 'undefined' && split[2] > 0 && split[2] < 60 ? split[2] : '00');

        }


        return out.join(":");

    }

}

module.exports = timeFormatter;